import { useContext } from "react"
import {
  PromosPlacementEngineContext,
  PromosPlacementEngineProps,
} from "modules/promos/contexts/PromosContext"

export const usePromosPlacementEngine = () =>
  useContext<PromosPlacementEngineProps>(PromosPlacementEngineContext)
